<template>
  <el-dialog class="user-dialog" v-bind="$attrs" v-on="$listeners">
    <div class="el-dialog-body-child">
      <el-form ref="queryForm" :model="queryParams" label-width="128px" :inline="true" class="search-form clearfix">
        <el-form-item class="search-field sku-attr fl" label="规格属性名称" prop="skuAttrName">
          <el-input v-model.trim="queryParams.skuAttrName" placeholder="请输入规格属性名称" clearable
            @keyup.enter.native="handleQuery" />
        </el-form-item>
        <div class="fr">
          <el-button plain @click="resetQuery">重 置</el-button>
          <el-button type="primary" @click="handleQuery">查 询</el-button>
        </div>
      </el-form>
      <div class="table-wrap">
        <div class="tips-box">
          <el-tag type="warning">温馨提示：重新搜索后，需重新勾选并点击保存方可见效。</el-tag><el-button class="search-all-selected"
            type="primary" :disabled="isQueryAllSelected" @click="handleSearchAllSelected"
            size="small">点击查看已分配的规格属性</el-button>
        </div>
        <div class="table-box">
          <auto-height-table instanceHeight="338" ref="categorySkuTable" :class="{ 'empty': list.length === 0 }"
            empty-text=" " v-loading="loading" :data="list" row-key="skuAttrId"
            @selection-change="handleSelectionChange" @row-click="clickRow">
            <el-table-column type="selection" :selectable="checkSelectable" :reserve-selection="true" width="55" align="center" />
            <el-table-column label="规格属性名称" prop="skuAttrName" align="center" min-width="120px" />
          </auto-height-table>
          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize" @pagination="getList" />
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">关 闭</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import { skuAttrApi } from "@/api"
export default {
  props: {
    categoryId: {
      type: [String, Number],
      default: ""
    }
  },
  watch: {
    async categoryId(val) {
      if (val) {
        this.queryParams.categoryId = val
        await this.getList()
        setTimeout(() => {
          this.isQueryAllSelected = false
          skuAttrApi.getSkuAttrIdsByCategoryId({ categoryId: val }).then((data) => {
            this.skuAttrIds = data.map((item) => item.skuAttrId)
            // 渲染选中表格
            this.renderSelectTable()
          })
        }, 200)
      }
    }
  },
  data() {
    return {
      isQueryAllSelected: false, // 是否已点击查询所有已分配
      //搜索条件参数
      queryParams: {
        categoryId: "", // 分类id 
        skuAttrName: "", // 规格属性名称
        skuAttrIds: "", // 规格属性id
        status: "1", // 只查启用的
        pageNum: 1,
        pageSize: 10
      },
      loading: false,
      list: [],
      total: 0,
      ids: [], // 已选中的项
      skuAttrIds: [], // 已分配的规格属性id列表
      isRenderPage: [], // 已渲染过的列表页码
      listSelectIds: [] // 已渲染过的用户id数据
    }
  },
  methods: {
    // 已被商品使用的规格属性 禁止操作
    checkSelectable(row, index) {
      if (row.beUsedByCategorySpu) {
        return false
      } else {
        return true
      }
    },
    // 查询所有已分配的角色
    handleSearchAllSelected() {
      if (this.isQueryAllSelected) { return }
      this.isQueryAllSelected = true // 是否查询已分配
      if (this.skuAttrIds.length === 0) {
        this.$modal.msgWarning("该分类暂无分配任何规格属性，请直接分配")
        return
      }
      this.queryParams.skuAttrIds = this.skuAttrIds.join(",")
      this.mixinResetForm("queryForm")
      this.handleQuery({ isSearchAllSelected: true })
    },
    // 清空选项
    clearSelection(isSearch) {
      this.$refs.categorySkuTable.clearSelection()
      this.isRenderPage = []
      this.listSelectIds = []
      if (isSearch) {
        return
      }
      this.mixinResetForm("queryForm")
      this.queryParams.pageNum = 1
      this.queryParams.skuAttrIds = ""
      this.skuAttrIds = []
      this.getList()
    },
    // 渲染选中的数据
    renderSelectTable() {
      if (
        this.isRenderPage.includes(this.queryParams.pageNum) ||
        this.skuAttrIds.length === 0
      ) {
        return
      }
      this.isRenderPage.push(this.queryParams.pageNum)
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i]
        if (this.skuAttrIds.includes(item.skuAttrId)) {
          this.listSelectIds.push(item.skuAttrId)
          this.$nextTick(() => {
            this.$refs.categorySkuTable.toggleRowSelection(item, true)
          })
        }
      }
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.skuAttrId)
    },
    //点击行
    clickRow(row) {
      // 被用过的禁止点击
      if (row.beUsedByCategorySpu) {
        return
      }
      this.$refs.categorySkuTable.toggleRowSelection(row)
    },
    /** 搜索按钮操作 data.isSearchAllSelected 是否是查询全部已选列表 不是的话 把搜索条件的skuAttrIds 设置为  "" */
    handleQuery(data) {
      if (!data || !data.isSearchAllSelected) {
        this.isQueryAllSelected = false
        this.queryParams.skuAttrIds = ""
      }
      // 点击搜索时 清空选项 重新开始
      this.clearSelection(true)
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.isQueryAllSelected = false
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询列表 */
    getList(options) {
      if (options?.type === "sizeChange") {
        this.isRenderPage = []
      }
      this.loading = true
      skuAttrApi
        .getList(this.queryParams)
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
          this.renderSelectTable()
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    // 保存
    async save() {
      // 获取已选中ids没有，listSelectIds有的userId：说明这些用户被移除勾选了
      const removeIds = [...new Set(this.listSelectIds)].filter(
        (item) => !new Set(this.ids).has(item)
      )
      // 获取已选中ids有，listSelectIds没有的userId： 说明这些是新增的
      const addIds = [...new Set(this.ids)].filter(
        (item) => !new Set(this.listSelectIds).has(item)
      )
      // 利用最先的userIds 去除移除勾选的 添加新增的
      let resultIds = []
      // 去掉移除勾选的
      resultIds = [...new Set(this.skuAttrIds)].filter(
        (item) => !new Set(removeIds).has(item)
      )
      // 添加新增的
      resultIds = resultIds.concat(addIds)
      const params = {
        categoryId: this.categoryId,
        skuAttrIds: resultIds
      }
      skuAttrApi
        .setSkuAttrIdsByCategoryId(params)
        .then((data) => {
          this.$modal.msgSuccess(data.msg)
          this.$emit("close")
        })
        .catch((err) => {
          this.$emit("close")
        })
    }
  }
}
</script>
<style lang="scss" scoped></style>
